import commonConfig from '@/config/base';

export default {
  ...commonConfig,
  siteTitle: 'CMS FOIA Portal',
  supportEmail: 'OPOLEFOIA@cms.hhs.gov'
};
